
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/her/news/[slug]",
      function () {
        return require("private-next-pages/her/news/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/her/news/[slug]"])
      });
    }
  